import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

const Template = ({ title, data, isImage }) => (
  <>
    {isImage ? (
      <div className="col-sm-12 col-lg-6 my-1">
        <div className="cit-inner d-flex flex-column">
          <label
            className="font-weight-bold mb-0 mr-2"
            style={{ color: '#65676b' }}
          >
            {title} :
          </label>
          <div className="narative-description p-2 my-2">
            {/* TODO: add image placeholder later */}
            {data ? (
              <img className="img img-responsive" src={data} alt={title} />
            ) : (
              'N/A'
            )}
          </div>
        </div>
      </div>
    ) : (
      <div className="col-12 my-1">
        <div className="cit-inner">
          <label className="font-weight-bold mb-0 mr-2 cit-label">
            {title}
          </label>
          <span className="cit-span">:</span>
          <span className="transaction-text p-0">{data}</span>
        </div>
      </div>
    )}
  </>
);

const ProfileInformation = ({ registrationInfo }) => {

  const address = `${_.get(registrationInfo, 'attributes.barangay') || ''} ${_.get(
    registrationInfo,
    'attributes.city'
  ) || ''}`;

  const checkIfOthersIsTrue = (primaryValue, otherValue) => {
    if (!primaryValue && !otherValue) return '- -';

    if (primaryValue === 'Others' && otherValue)
      return `Other ( ${otherValue || '- -'} )`;

    return primaryValue;
  };

  return _.isEmpty(registrationInfo) ? (
    <div className="row d-flex  mb-1 p-3 ml-3">There are no items found.</div>
  ) : (
    <div className="row d-flex  mb-1 p-3">
      <Template
        title="Last Name"
        data={_.get(registrationInfo, 'attributes.first_name') || '- -'}
      />
      <Template
        title="First Name"
        data={_.get(registrationInfo, 'attributes.last_name') || '- -'}
      />
      <Template
        title="Middle Name"
        data={_.get(registrationInfo, 'attributes.middle_name') || '- -'}
      />
      <Template
        title="Birthday"
        data={_.get(registrationInfo, 'attributes.birth_date') || '- -'}
      />
      <Template
        title="Age"
        data={_.get(registrationInfo, 'attributes.age') || '- -'}
      />
      <Template
        title="Sex"
        data={_.get(registrationInfo, 'attributes.sex') || '- -'}
      />
      <Template title="Address" data={address || '- -'} />
      <Template
        title="Contact Number"
        data={_.get(registrationInfo, 'attributes.contact_number') || '- -'}
      />
      <Template
        title="Email"
        data={_.get(registrationInfo, 'attributes.email') || '- -'}
      />
      <Template
        title="Civil Status"
        data={_.get(registrationInfo, 'attributes.civil_status') || '- -'}
      />
      <Template
        title="Categories"
        // data={employmentCategory || '- -'}
        data={checkIfOthersIsTrue(
          _.get(registrationInfo, 'attributes.category'),
          _.get(registrationInfo, 'attributes.category_other')
        )}
      />
      <Template
        title="Employment Status"
        data={checkIfOthersIsTrue(
          _.get(registrationInfo, 'attributes.employment_status'),
          _.get(registrationInfo, 'attributes.employment_status_other')
        )}
      />
      <Template
        title="Philhealth Number"
        data={
          _.get(registrationInfo, 'attributes.philhealth_id_number') || '- -'
        }
      />
      <Template
        title="Name of Employer"
        data={_.get(registrationInfo, 'attributes.employer_name') || '- -'}
      />
      <Template
        title="Employer's Address"
        data={_.get(registrationInfo, 'attributes.employer_address') || '- -'}
      />
      <Template
        title="Employer's Contact Number"
        data={
          _.get(registrationInfo, 'attributes.employer_contact_number') || '- -'
        }
      />
      <Template
        title="Employer's Privince"
        data={_.get(registrationInfo, 'attributes.employer_province') || '- -'}
      />
      <Template
        title="Id"
        data={_.get(registrationInfo, 'attributes.valid_id') || '- -'}
      />
      <div className="d-flex flex-md-wrap w-100">
        <Template
          title="Id Photo"
          isImage
          data={_.get(registrationInfo, 'attributes.valid_id_photo_url')}
        />
        <Template
          title="1x1 Picture"
          isImage
          data={_.get(registrationInfo, 'attributes.id_picture')}
        />
      </div>
    </div>
  );
};

Template.propTypes = {
  data: PropTypes.node, // any props
  title: PropTypes.string,
  isImage: PropTypes.bool,
};

Template.defaultProps = {
  title: '',
  data: '',
  isImage: false,
};

ProfileInformation.propTypes = {
  registrationInfo: PropTypes.instanceOf(Object).isRequired,
};

export default ProfileInformation;
